import type { Event } from '@/config/objects/events';
import { useOutletContext } from 'react-router-dom';

interface EventContext {
  event: Event | undefined;
  isLoading: boolean;
}

export function useEventContext() {
  return useOutletContext<EventContext>();
}
